/**
 * @module FE-CU42_緊急連絡先設定_削除モーダル画面
 */
export default {
  name: 'DeleteConfirmModal',
  props: ['contact', 'dialog', 'sortFlag'],
  data() {
    return {
      childDialog: this.dialog,
      childContact: this.contact,
    };
  },
  computed: {},
  /** @type {Methods} */
  methods: {
    /**
     * いいえボタン押下時処理
     */
    closeDialog() {
      this.childDialog = false;
    },
    /**
     * はいボタン押下時処理
     */
    deleteContact() {
      this.$emit('delete-contact', this.childContact.id);
      this.closeDialog();
    },
  },
};
